import { apiFetch } from 'modules/shared/fetch';
import { createCorrelationId } from 'utils/createUniqueId';

const correlationId = createCorrelationId();

export default class OrganisationService {
  /**
   * Gets an organisation data
   *
   * @returns {Object} The organisation data
   */
  static async getOrganisation({ appEnvironment }) {
    const getOrg = apiFetch('/users/organization', {
      method: 'GET',
      appEnvironment,
      headers: {
        'lean-correlation-id': correlationId,
      },
    });

    const { data: organisation } = await getOrg;
    return organisation;
  }

  /**
   * Activate an organisation
   *
   * @param {Object} body - The data from the activation form
   *
   * @returns {boolean} true if activation successful, corresponding error otherwise
   */
  static async activateOrganisation({ appEnvironment, body }) {
    const activateOrg = apiFetch('/users/kyb/verify', {
      method: 'POST',
      appEnvironment,
      headers: {
        'lean-correlation-id': correlationId,
      },
      body,
    });

    const { data: activeOrganisation } = await activateOrg;
    return activeOrganisation;
  }
}
